import React from 'react';
import styled from 'styled-components';
import { useAnnouncementGetQuery } from '@services/api';
import { theme } from '@styles/theme';
import { AnnouncementContent } from './AnnouncementContent';

const Container = styled.div`
  max-width: ${theme.layout.wideMaxWidth};
  margin: 0 auto;
  padding: ${theme.spacing.md} ${theme.spacing.lg};

  @media (max-width: ${theme.breakpoints.tablet}) {
    padding: ${theme.spacing.md};
  }
`;

export const AnnouncementBanner: React.FC = () => {
  const { data, isError } = useAnnouncementGetQuery(undefined, { refetchOnMountOrArgChange: true });
  if (isError || !data?.content?.trim()) return null;

  return (
    <Container>
      <AnnouncementContent content={data.content} />
    </Container>
  );
};
